import React, { useEffect, useState, createContext, useContext, useRef } from 'react';
import { auth } from '../firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { getFunctions, httpsCallable } from 'firebase/functions';
import MenuBar from '../components/MenuBar';
import { FaFilter } from 'react-icons/fa';
import '../styles/MemberSearch.css';
import { app } from '../firebaseConfig';
import ProfileImageUpload from '../components/ProfileImageUpload';
import OtherMemberProfile from '../components/OtherMemberProfile';
import { Timestamp } from 'firebase/firestore'; // 追加: FirebaseのTimestampをインポート
import { FaSliders } from "react-icons/fa6";
import { FaArrowDownWideShort } from "react-icons/fa6";
const MemberContext = createContext([]);
export const useMembers = () => useContext(MemberContext);

const MemberSearch = () => {
  const [members, setMembers] = useState([]);
  const [user] = useAuthState(auth);
  const [filterOption, setFilterOption] = useState(null);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [imageUrl, setImageUrl] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [profile, setProfile] = useState({ photoURL: '' });
  const [profileLoading, setProfileLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();
  const scrollPositionRef = useRef(0);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false); // 追加


  useEffect(() => {
    const askNotificationPermission = async () => {
      if (Notification.permission === 'default') {
        try {
          const permission = await Notification.requestPermission();
          console.log("🔔 通知の許可状態:", permission);
        } catch (err) {
          console.error("通知許可の取得エラー:", err);
        }
      }
    };
  
    askNotificationPermission();
  }, []);
  

  // プロフィール情報を取得
  useEffect(() => {
    const fetchProfile = async () => {
      if (user) {
        console.log("Fetching user profile...");
        const docRef = doc(db, 'members', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setImageUrl(data.photoURL || '');
          setProfile(data);
          console.log("User profile loaded:", data);
        } else {
          console.log("No user profile found.");
        }
        setProfileLoading(false);
      }
    };

    fetchProfile();
  }, [user]);

  // フィルタオプションの取得
  useEffect(() => {
    const fetchFilterOption = async () => {
      if (user) {
        console.log("Fetching filter options...");
        try {
          const filterDocRef = doc(db, 'filterOptions', user.uid);
          const filterDocSnap = await getDoc(filterDocRef);
          if (filterDocSnap.exists()) {
            const data = filterDocSnap.data();
            setFilterOption({
              ...data,
              minAge: parseInt(data.minAge, 10),
              maxAge: parseInt(data.maxAge, 10),
            });
            console.log("Filter options loaded:", data);
          } else {
            const defaultFilterOption = {
              gender: 'all',
              location: 'all',
              major: 'all',
              maxAge: 70,
              minAge: 18,
            };
            await setDoc(filterDocRef, defaultFilterOption);
            setFilterOption(defaultFilterOption);
            console.log("Default filter options set.");
          }
        } catch (error) {
          console.error("Error fetching filter options:", error);
        }
      }
    };

    fetchFilterOption();
  }, [user]);

  const getTimeMarkerClass = (useDate) => {
    if (!useDate) return 'gray';
  
    let useDateTime;
  
    if (useDate instanceof Timestamp) {
      useDateTime = useDate.toDate();
    } else if (useDate._seconds) {
      useDateTime = new Date(useDate._seconds * 1000);
    } else if (typeof useDate === 'string') {
      useDateTime = new Date(useDate);
    } else {
      console.log("Unknown use_date format:", useDate);
      return 'gray';
    }
  
    const now = new Date();
    const timeDifferenceInHours = (now - useDateTime) / (1000 * 60 * 60);
  
    if (timeDifferenceInHours <= 1) {
      return 'green';
    } else if (timeDifferenceInHours <= 24) {
      return 'blue';
    } else if (timeDifferenceInHours <= 72) {
      return 'orange';
    } else {
      return 'gray';
    }
  };
  

  const getTimeDifferenceLabel = (useDate) => {
    if (!useDate) {
      console.log("use_date is undefined or null");
      return '';
    }
  
    let useDateTime;
  
    // Firebase Timestampオブジェクトの場合
    if (useDate instanceof Timestamp) {
      useDateTime = useDate.toDate();
    }
    // _secondsフィールドを持つオブジェクトの場合
    else if (useDate._seconds) {
      useDateTime = new Date(useDate._seconds * 1000); // _seconds をミリ秒に変換
    }
    // 文字列形式の場合
    else if (typeof useDate === 'string') {
      useDateTime = new Date(useDate);
    }
    // その他の形式の場合
    else {
      console.log("Unknown use_date format:", useDate);
      return '';
    }
  
    if (isNaN(useDateTime)) {
      console.log("Invalid use_date:", useDate);
      return '';
    }
  
    const now = new Date();
    const timeDifferenceInHours = (now - useDateTime) / (1000 * 60 * 60); // 時間単位に変換
    const timeDifferenceInDays = timeDifferenceInHours / 24; // 日単位に変換
  
    if (timeDifferenceInHours <= 1) {
      return '1時間以内';
    } else if (timeDifferenceInHours <= 24) {
      return '24時間以内';
    } else if (timeDifferenceInDays <= 3) {
      return '3日以内';
    } else if (timeDifferenceInDays <= 7) {
      return '1週間以内';
    } else if (timeDifferenceInDays <= 30) {
      return '1ヶ月以内';
    } else {
      return '1ヶ月以上前';
    }
  };
  

const fetchMembers = async () => {
  if (!user || !hasMore || loadingMembers) return;

  console.log("Fetching members...");
  setLoadingMembers(true); // ローディング開始

  try {
    const functions = getFunctions(app, "asia-northeast2");
    const fetchFilteredMembers = httpsCallable(functions, "fetchFilteredMembers");

    const idToken = await auth.currentUser.getIdToken();
    const result = await fetchFilteredMembers({
      ...filterOption,
      lastDoc,
      limit: 20,
    });

    const newMembers = result.data;
    console.log("Fetched members:", newMembers);

    if (newMembers.length === 0) {
      setHasMore(false);
    } else {
      setLastDoc(newMembers[newMembers.length - 1].id);
      setMembers((prevMembers) =>
        [...prevMembers, ...newMembers].filter(
          (member, index, self) =>
            index === self.findIndex((m) => m.id === member.id) // 重複排除
        )
      );
    }
  } catch (err) {
    console.error("Error fetching members:", err.message);
  } finally {
    setLoadingMembers(false); // ローディング終了
  }
};

  

  useEffect(() => {
    if (filterOption) {
      console.log("Filter options updated. Fetching members...");
      setHasMore(true);
      setLastDoc(null);
      setMembers([]);
      fetchMembers();
    }
  }, [filterOption]);

  useEffect(() => {
    console.log("Triggered useEffect with id:", id);
  
    const fetchAndSetSelectedMember = async () => {
      if (!id) {
        console.log("No id in URL.");
        setIsModalOpen(false); // モーダルを閉じる
        return;
      }
  
      console.log("Looking for member with id:", id);
  
      // メンバーを探す
      let member = members.find((m) => m.id === id);
      console.log("Found member in list:", member);
  
      // メンバーが見つからない場合は再取得
      if (!member && !loading) {
        console.log("Member not found in current list, fetching members...");
        await fetchMembers();
        member = members.find((m) => m.id === id);
        console.log("Member found after fetch:", member);
      }
  
      if (member) {
        setSelectedMember(member);
        setIsModalOpen(true);
        console.log("Selected member set to:", member);
        console.log("Modal state set to open.");
      } else {
        console.log("No member found for id:", id);
        setIsModalOpen(false);
      }
    };
  
    fetchAndSetSelectedMember();
  }, [id, members, loading]);
  
  const handleFilterApply = () => {
    navigate('/filtered_members', { state: { filterOption, members } });
  };

  const handleProfileClick = (member) => {
    if (!member) {
      console.error("Error: No member object passed to handleProfileClick.");
      return;
    }
  
    // members 配列内での currentIndex を取得
    const index = members.findIndex(m => m.id === member.id);
  
    console.log("Navigating to:", member.id);
    console.log("Current Index:", index);
    console.log("Members List:", members.map(m => m.id));
  
    navigate(`/member_search/partner/${member.id}`, { state: { members, currentIndex: index } });
  };
  

  
  
  

  const closeModal = () => {
    console.log("Closing modal...");
    setIsModalOpen(false);
    setSelectedMember(null);
    console.log("isModalOpen set to false.");
    navigate('/member_search');
  };
  
  

  const isNewMember = (member) => {
    if (!member || !member.createdAt) return false;
  
    let registrationDate;
  
    // Firestore Timestamp の形式に応じて変換
    if (member.createdAt._seconds) {
      registrationDate = new Date(member.createdAt._seconds * 1000);
    } else {
      console.error("Invalid createdAt format:", member.createdAt);
      return false;
    }
  
    const currentDate = new Date();
    const diffTime = Math.abs(currentDate - registrationDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
    return diffDays <= 14; // 2週間以内なら新規メンバー
  };
  
    // Firestore に order を保存
    const updateOrderInFirestore = async (newOrder) => {
      if (!user) return;
      try {
        const filterDocRef = doc(db, 'filterOptions', user.uid);
        await setDoc(filterDocRef, { order: newOrder }, { merge: true });
        setFilterOption(prev => ({ ...prev, order: newOrder }));
        console.log(`Order updated to: ${newOrder}`);
        window.location.reload();
      } catch (error) {
        console.error("Error updating order:", error);
      }
    };
  
  

  if (profileLoading) return <div></div>;

  return (
    <MemberContext.Provider value={members}>
      <div className="member-search-container">
      <p className="settings-title-x"> ユーザーを探す</p>
      <div className="button-container-x">
  <button onClick={() => handleFilterApply()} className="filter-button">
    <FaSliders /> 絞り込み
  </button>
  <button className="filter-button" onClick={() => setIsOrderModalOpen(true)}>
            <FaArrowDownWideShort /> 並び替え
          </button>
</div>

        <div className="member-grid">
          {members.map((member) => (
            <div
              key={member.id}
              className={`member-card ${isNewMember(member) ? 'new-member' : ''}`}
              onClick={() => handleProfileClick(member)}
            >
              <div className="image-container">
                <img
                  src={member.photoURL || '/images/default.png'}
                  alt="Profile"
                  className="member-image"
                />
                
                {isNewMember(member) && <span className="new-badge">NEW</span>}
              </div>
              <div className="member-info">
  <span className="member-name">
    <span className={`time-marker ${getTimeMarkerClass(member.use_date)}`}></span>
    {member.name} 
  </span>
  
  <span className="member-name-x">
    <span className="member-age">{member.age}歳 {member.location}</span>
  </span><br></br>
  <span className="member-name-x">
    <span className="member-age">{member.sex}/{member.sexualOrientation}</span>
  </span>
</div>

            </div>
          ))}
        </div>

        {isModalOpen && selectedMember && (
  <div className="othermember-modal-overlay" onClick={closeModal}>
    <div className="othermember-modal-content" onClick={(e) => e.stopPropagation()}>
      <button className="othermember-close-button" onClick={closeModal}>＜</button>
      <OtherMemberProfile member={selectedMember} />
    </div>
  </div>
)}


        {imageUrl === '' && (
          <div className="othermember-modal-overlay">
            <div className="othermember-modal-content">
              <ProfileImageUpload
                user={user}
                imageUrl={imageUrl}
                setImageUrl={setImageUrl}
                setProfile={setProfile}
              />
            </div>
          </div>
        )}

                {/* 並び替え選択モーダル */}
                {isOrderModalOpen && (
          <div className="order-modal-overlay" onClick={() => setIsOrderModalOpen(false)}>
<div className="order-modal-content" onClick={(e) => e.stopPropagation()}>
  <p className={`order-option ${filterOption?.order === "recommend" ? "selected" : ""}`} 
     onClick={() => { updateOrderInFirestore("recommend"); setIsOrderModalOpen(false); }}>
    おすすめ順
  </p>
  <p className={`order-option ${filterOption?.order === "login" ? "selected" : ""}`} 
     onClick={() => { updateOrderInFirestore("login"); setIsOrderModalOpen(false); }}>
    ログイン順
  </p>
  <p className={`order-option ${filterOption?.order === "authentification" ? "selected" : ""}`} 
     onClick={() => { updateOrderInFirestore("authentification"); setIsOrderModalOpen(false); }}>
    登録順
  </p>
</div>

          </div>
        )}

        <MenuBar />
      </div>
    </MemberContext.Provider>
  );
};

export { MemberContext };
export default MemberSearch;